import dynamic from 'next/dynamic';
import { Fragment } from 'react';

import { DesktopCatalog } from './DesktopCatalog';

type EmptyProps = Record<string, unknown>;

const MobileCatalogWrapper = dynamic<EmptyProps>(() => import('./MobileCatalog').then((mod) => mod.MobileCatalog), {
  ssr: false,
});

export const Catalog = () => {
  return (
    <Fragment>
      <DesktopCatalog />
      <MobileCatalogWrapper />
    </Fragment>
  );
};
